import React from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import ExpensesLineChart from "../../../../components/PagesComponents/Financial/Accountant/Expenses/ExpensesLineChart.component";
import ExpensesPieChart from "../../../../components/PagesComponents/Financial/Accountant/Expenses/ExpensesPieChart.component";
import "../../../../styles/Pages/Financial/Accountant/Expenses/Expenses.style.css";
import CategoricalExpensesInRupee from "../../../../components/PagesComponents/Financial/Accountant/Expenses/CategoricalExpensesInRupee.component";

const Body = ({ donutChartData, lineChartData, expenseData }) => {
  return (
    <section className="accountentExpenses">
      <Helmet>
        <title>Expenses</title>
        <meta
          name="description"
          content="A powerful organization management system to streamline workflows and improve efficiency."
        />
        <meta
          name="keywords"
          content="organization management, workflow automation, business management, employee tracking"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Main stream expenses"} />
      <div className="mainExpensesContainer">
        <div className="expensesContainer">
          <div className="expensesGraph">
            <ExpensesLineChart graphData={lineChartData} />
          </div>
          <div className="expensesPieChart">
            <ExpensesPieChart donutChartData={donutChartData} />
          </div>
        </div>
        <div className="secondaryContainer">
          <div className="mainStreamEnrollmentRatio">
            <div className="mainStreamEnrollmentRatioContent">
              <h3>Main stream enrollment ratio</h3>
              <ul>
                <li>Expense is inversly propotional to revenue.</li>
                <li>
                  If expense has positive growth, this particular expense should
                  be reduced.
                </li>
                <li>
                  If expense has negative growth, this particular expense has
                  good health.
                </li>
              </ul>
            </div>
            <div className="academicExpenseSection">
              Click here to go to academic expenses section
            </div>
          </div>
          <div className="categoricalExpensesInRupee mb-2">
            <CategoricalExpensesInRupee expenseData={expenseData} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
